import React from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { useLoaderData, Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";

const createTableRows = (option) => {
  return option.map((c) => {
    return [c.Id, c.Name, c.Value, c.Category];
  });
};

export default function OptionsTable() {
  const { option } = useLoaderData();
  const rows = createTableRows(option);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "Namn",
      options: {
        filter: false,
      },
    },
    {
      name: "Värde",
      options: {
        filter: false,
      },
    },
    {
      name: "Kategori",
      options: {
        filterList: ["setting"],
      },
    },
  ];

  // const columns = createTableCols();

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    filterType: "dropdown",
    responsive: "standard",
    downloadOptions: {
      separator: ";",
      filename: "all_options.csv",
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],

    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
